
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BrainCircuit } from "lucide-react";
import { AIPersonalityDescription } from "./ai-personality/AIPersonalityDescription";
import { AIPersonalityGrid } from "./ai-personality/AIPersonalityGrid";
import { useAIPersonalityPanel } from "./ai-personality/useAIPersonalityPanel";

export type AIPersonality = 'ultraterrestrial' | 'terrestrial' | 'passenger' | 'static' | 'librarian' | 'entity247b';

// Create a consistent key for all AI personality queries
export const AI_PERSONALITY_QUERY_KEY = 'aiPersonality';

export const AIPersonalityPanel = () => {
  const { 
    aiPersonality, 
    isLoading, 
    handlePersonalityChange 
  } = useAIPersonalityPanel();
  
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <BrainCircuit className="h-5 w-5" />
          Voice of the Monolith
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4">
          <AIPersonalityDescription />
          
          <AIPersonalityGrid
            currentPersonality={aiPersonality}
            isDisabled={isLoading}
            onPersonalityChange={handlePersonalityChange}
          />
        </div>
      </CardContent>
    </Card>
  );
};
